import { BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CHART_GRID_COLOR, CHART_AXIS_TICK_STYLE } from './chartPalette';
import { CustomChartTooltip } from './CustomChartTooltip';
import { ChartCard } from '@/components/ui/chart-card';

interface Entry {
  fullName: string;
  followersGained: number;
}

/**
 * TopGrowthBarChart — re-skinned for PR (m.8) Phase 2 onto the
 * canonical `<ChartCard>` chrome.
 */
export function TopGrowthBarChart({ entries }: { entries: Entry[] }) {
  if (!entries || entries.length === 0) {
    return (
      <ChartCard eyebrow="Top 5 Growth Contributors" title="Followers Gained">
        <div className="py-6 text-center text-eyebrow-sm text-muted-foreground">
          No data yet
        </div>
      </ChartCard>
    );
  }
  return (
    <ChartCard eyebrow="Top 5 Growth Contributors" title="Followers Gained">
      <div style={{ width: '100%', height: Math.max(180, entries.length * 48) }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={entries} layout="vertical" margin={{ top: 8, right: 40, left: 8, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR} />
            <XAxis type="number" tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} />
            <YAxis type="category" dataKey="fullName" tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} width={140} />
            <Tooltip content={<CustomChartTooltip />} />
            <Bar dataKey="followersGained" name="Followers Gained" fill="#3d2f0b" isAnimationActive={false}>
              <LabelList
                dataKey="followersGained"
                position="right"
                style={{ fill: '#3d2f0b', fontSize: 11, fontFamily: 'Inter, sans-serif' }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </ChartCard>
  );
}
